class SimpleSlider {
    constructor($slider, index) {
        if (!$slider) {
            return;
        }
        this.timeoutIds = [];
        $slider.SimpleSliderInstance = this;
        this.breakPoint = getComputedStyle(document.querySelector(':root')).getPropertyValue('--breakpoint--tablet-l');
        this.startIndex = 1;
        this.haltScrolling = false;
        this.$slider = $slider;
        this.$currentSlide = null;
        this.duration = 4000;
        this.setup($slider, index);
    }

    get shouldSlide() {
        // check if slider is in viewport
        const rect = this.$slider.getBoundingClientRect();
        const isInViewport = (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );

        // check if a breakpoint could be determined
        if (this.breakPoint === '' || !this.breakPoint) {
            return isInViewport;
        }

        // check if slider is not on desktop
        const isNotDesktop = matchMedia(`(max-width: ${this.breakPoint})`).matches;

        return isInViewport && isNotDesktop;
    }

    setup() {
        this.$sliderList = this.$slider.querySelector('[data-simple-slider-list]');
        this.$sliderItems = this.$slider.querySelectorAll('[data-simple-slider-item]');

        // if a slider was found, then it should have items
        if (this.$sliderItems.length === 0) {
            console.warn(`SimpleSlider: No items found within ${this.$slider}`);
            return;
        }

        // if the slider does not have enough items, then it autoplay is not needed
        if (this.$sliderItems.length < 2) {
            console.warn('SimpleSlider: Only one item found, no slider needed');
            return;
        }

        // if the window scrolls, then check if the slider should slide
        window.addEventListener('scroll', () => {
            const isInViewport = this.shouldSlide;
            if (isInViewport) {
                this.resumeScrolling();
            } else {
                this.pauseScrolling();
            }
        });

        // start on second slide
        this.setCurrentSlide(this.$sliderItems[this.startIndex]);

        this.setupScrolling();
    }

    clearAllTimeouts() {
        this.timeoutIds.forEach((timeoutId) => {
            clearTimeout(timeoutId);
        });
        this.timeoutIds = [];
    }

    pauseScrolling() {
        this.clearAllTimeouts();
        this.haltScrolling = true;
    }

    resumeScrolling() {
        this.clearAllTimeouts();
        this.haltScrolling = false;
        this.setupScrolling();
    }

    setupScrolling() {
        this.timeoutIds.push(setTimeout(this.scrollTimeout, this.duration, this));
    }

    getNextSlide() {
        let getNext = false;
        let $nextSlide = null;

        // loop over all slides, until the next slide is set
        [...this.$sliderItems].every(($slide) => {
            // if in the previous iteration, the current slide was found, getNext will have been set to true
            if (getNext) {
                $nextSlide = $slide;
                // return false to break the loop
                return false;
            }

            // if the current slide is found, then set getNext to true
            // in the next iteration, the next slide will be set
            if ($slide === this.$currentSlide) {
                getNext = true;
            }
            return true;
        });

        if (!$nextSlide) {
            // if no next slide was found, it's because the current slide
            // is the last slide. In that case, return the first slide
            return this.$sliderItems[0];
        }
        return $nextSlide;
    }

    setCurrentSlide($currentSlide) {
        this.$currentSlide = $currentSlide;
        this.$currentSlide.parentNode.scrollTo({left: this.$currentSlide.offsetLeft, behavior: 'smooth'});
    }

    scrollTimeout(SimpleSliderInstance){
        // if shouldSlide is false, then pause scrolling, and break out of the function
        if (!SimpleSliderInstance.shouldSlide) {
            SimpleSliderInstance.pauseScrolling();
            return;
        }

        // otherwise, check if haltScrolling was set to true
        // if it was not, then scroll to the next slide, and setup a new timeout
        if (!SimpleSliderInstance.haltScrolling) {
            const $nextSlide = SimpleSliderInstance.getNextSlide();
            SimpleSliderInstance.setCurrentSlide($nextSlide);
            SimpleSliderInstance.timeoutIds.push(
                setTimeout(SimpleSliderInstance.scrollTimeout, SimpleSliderInstance.duration, SimpleSliderInstance)
            );
        }
    }
}

function setupAllSliders() {
    // get all sliders
    const $sliders = document.querySelectorAll('[data-simple-slider="auto-play"]');

    // check if there are any sliders
    if ($sliders.length === 0) {
        return;
    }

    // setup each slider
    $sliders.forEach(($slider, index) => {
        new SimpleSlider($slider, index);
    });
    return null;
}

export default setupAllSliders();
